import Cookies from "js-cookie";

const SessionManager = {
    // ---------------- COOKIES (Client-Readable) ----------------
    setCookie: (name, value, days = 1) => {
        Cookies.set(name, value, { expires: days / 24, path: "/" });
    },

    getCookie: (name) => {
        return Cookies.get(name);
    },

    removeCookie: (name) => {
        Cookies.remove(name, { path: "/" });
    },

    // ---------------- SESSION STORAGE ----------------
    setSession: (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
    },

    getSession: (key) => {
        const data = localStorage.getItem(key);
        try {
            return JSON.parse(data);
        } catch {
            return data;
        }
    },

    removeSession: (key) => {
        localStorage.removeItem(key);
    },

    clearSession: () => {
        localStorage.clear();
    }
};

export default SessionManager;
